function toggleHTMLOverflow(val) {
	document.documentElement.style.overflowY = val;
}

function toggleElements(hidden_els, bool) {
  hidden_els.forEach(function(item) {
    item.setAttribute("aria-hidden", bool);
  });
}

function openShipping(id,hidden_els) {
  if (id) {
    id.removeAttribute("aria-hidden");  
  }
  
  toggleElements(hidden_els, "true");
  toggleHTMLOverflow("hidden");
  if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
    BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
    BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
}
}

function closeShipping(id,hidden_els) {
  if (id) {
    id.setAttribute("aria-hidden", "true");
  }
  
  toggleElements(hidden_els, "false");
  toggleHTMLOverflow("auto");
}


function setCircles(){
  
  w=$(document).width();
  
  
  $('#shopify-section-16268999234a0bef3e').height($('#shopify-section-16268999234a0bef3e .grid-block').height());
  
  $('.align--left .grid__item.image_wrapper.icon-4, #custom__item--a13a963e-308c-4117-8cc8-4f690578cbc9 .no-img-icon.bg-icon-blue').each(function(){
    g_height=$(this).height();
    g_width=$(this).width();
    
    if(g_height>g_width){
      var dif=g_height-g_width;
    
      $(this).width(g_height);
      if(dif>5){
     	 $(this).css('marginLeft',0-dif);
      }
    }else{
       $(this).width('auto');
      $(this).css('marginLeft',0);
    }
    
    if(w<768){
        if(g_width>g_height){
          
          $(this).height(g_width);
        }
     }
      
      
  		
  });
  
  
  $('.align--right .grid__item.image_wrapper.icon-4').each(function(){
    //console.log(this);
    g_height=$(this).height();
    g_width=$(this).width();
    var window_width = $(window).width();
    var half = window_width/2;
    
    //if(window_width > 768 && g_width > half){
      //$(this).css('max-width','50vw');
    //}
    
//     if(g_width > half){
//       console.log('height before ' + g_height);
//        console.log('greater than half');
//       console.log(half);
//       $(this).width(half);
//       console.log('height after ' + $(this).height());
      
//       //g_height=$(this).height();
// 	  //g_width=$(this).width();
      
      
//     }
    
    
    if(g_height>g_width){
      var dif=g_height-g_width;
      
      console.log('g_height: ' + g_height);
       console.log('dif: ' + dif);
      $(this).width(g_height);
      if(dif>5){
     	 $(this).css('marginRight',0-dif);
      }
      else {
       //hopefully adding this doesn't break anything
        
        $(this).css('marginRight',0);
      }
    }else{
      
       $(this).width('auto');
      $(this).css('marginRight',0);
    }
  		
  });
  
 
  
  
  
  $('.shape-circle.bg-rust img.full-width').each(function(){
    if(w>767){
      $(this).parent().css('width','50vw');
      if($(this).parent().width()>$(this).parent().height()){
     	 $(this).parent().css('height','50vw');
      }
      $(this).parent().css('overflow','hidden');
      $(this).css('height','100%');
      var h=$(this).height();
      $(this).css('width',h);
      $(this).css('maxWidth','unset');
     
    }
  });
  
  $('.product-info__usage.product__section.product__alt1.product__bg.product-info__grid .product__sec__image img, .custom__item.custom__grid.custom__grid-align--one-half-one-half .grid__item.image_wrapper .shape-circle img').each(function(){
    if(w>767){
    
      $(this).parent().css('width','100%');
      $(this).parent().css('maxWidth','50vw');
      $(this).parent().css('overflow','hidden');
      pw=$(this).parent().width();
      
      $(this).css('height','100%');
      //added this to fix on resize
      $(this).css('width','100%');
      
      if($(this).height()<pw){
        $(this).height(pw);
      }
      var h=$(this).height();
      $(this).css('width',h);
      $(this).css('maxWidth','unset');
      //$(this).css('color','red');
    }
  });
  
  
  $('.product-info__tips.product-info__usage.product__section.product__alt2.product__bg>.product__sec__image svg').each(function(){
   ph=$(this).parent().height();
   pw=$(this).parent().width();
  
  if(ph>pw){
    $(this).parent().css('position','relative');
    $(this).css('height','100%').css('position','absolute').css('right','0');
    
  }else{
    $(this).parent().css('position','unset');
    $(this).css('height','100%').css('position','unset').css('right','unset');
  }
  
});
  
  }





window.onload=function(){
    
  var button = document.getElementById("shipping-button"),
      buttons = document.getElementsByClassName("shipping_button"),
      drawers = document.getElementsByClassName("drawer__close"),
      dbs = document.getElementsByClassName("drawer__background"),
      ssab   = document.getElementById('shopify-section-announcement-bar'),
	  nw     = document.querySelector('.navbar__wrapper'),
	  nb     = document.querySelector('.navbar__background'),
	  main   = document.getElementById('main'),
	  ssi    = document.getElementById('shopify-section-instagram'),
	  ssf    = document.getElementById('shopify-section-footer'),
	  sa     = document.getElementById('screenreader-announce'),
      close  = document.querySelector('#shipping-drawer .drawer__close'),
      hidden_els = [ssab,nw,nb,main,ssi,ssf,sa],
      id     = document.getElementById('shipping-drawer'),
      db     = document.querySelector('#shipping-drawer .drawer__background');
  
  var attr;
  if(id != null){
      attr   = id.attributes;
  }
  
//   if(button){
    
//     db.addEventListener("click", function(e) {
//       closeShipping(id, hidden_els);
//     });
//     close.addEventListener("click", function(e) {
//       closeShipping(id, hidden_els);
//     });
    
//     button.addEventListener("click", function(e) {
//         if (attr['aria-hidden'].value == "true") {
//             openShipping(id, hidden_els);
//         } else {
//             closeShipping(id, hidden_els);
//         }
//     });
//   }
  
  if(buttons) {

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", function(e){
        var drawerId = this.getAttribute('data-a11y-dialog-show');
        if(drawerId != null){
          var activeDrawer = document.getElementById(drawerId);
          var drawerAttr = activeDrawer.attributes;
          if(drawerAttr['aria-hidden'].value == "true"){
              openShipping(activeDrawer, hidden_els);
          }else {
              closeShipping(activeDrawer, hidden_els);
          }
        }
      });
    }
    
  
  }
  
  if(drawers) {
   	 for (var i = 0; i < drawers.length; i++) {
       drawers[i].addEventListener("click", function(e){
	     var item_id = this.getAttribute('data-drawer-id');
         var item = document.getElementById(item_id);
         closeShipping(item, hidden_els);
       });
     }
  }
  
  if(dbs) {
   	 for (var i = 0; i < dbs.length; i++) {
       dbs[i].addEventListener("click", function(e){
	     var item_id = this.getAttribute('data-drawer-id');
         var item = document.getElementById(item_id);
         closeShipping(item, hidden_els);
       });
     }
  }

  var skintypes = document.querySelector('.custom-field__skin-type .custom-field--value');
  if(skintypes != null){
    var html = skintypes.innerHTML;
    var newHtml = html.replace(/\//g, "<br>");
    skintypes.innerHTML = newHtml;
  }
  
  var productNav = document.getElementById("productNav");
  if(productNav != null){
    var navitems = productNav.getElementsByClassName("scroll");
    for (var i = 0; i < navitems.length; i++) {
      navitems[i].addEventListener("click", function() {
      var current = productNav.getElementsByClassName("active");
      current[0].className = current[0].className.replace(" active", "");
      this.className += " active";
      });
    }
  }
  
  
  //setCircles();
  

  $('body').on('click', '.store_benefits_button', function(event){
    var e = this;
    var index = $(e).data('index');
    var title = $('#drawer-heading-' + index).html();
    var content = $('#drawer-content-' + index).html();
    
    $('#shipping-drawer-generic-title').html(title);
    $('#shipping-drawer-generic-content').html(content);
    
    openShipping($('#shipping-drawer-generic')[0], hidden_els);
    
    event.preventDefault();
  });

    
  
  $('#mobile-navigation ul li.has-children>a').click(function(e){
  	e.preventDefault();
    $(this).siblings('ul').slideToggle();
  });
  
}

/*var iconSvg = $('.no-img-icon').width();
$( ".no-img-icon svg" ).each(function() {
  $( this ).css({'height':iconSvg+'px'});
});*/


const button = document.querySelector('#filter-btn');
if(button != null){
	button.addEventListener('click', toggleClass, false);
}

function toggleClass() {
  var x = document.querySelector('#filter-list');
  x.classList.toggle('active');
  button.classList.toggle('filter-open');
}



const button2 = document.querySelector('.ingredient-list a');
if(button2 != null){
	button2.addEventListener('click', toggleClass2, false);
}

function toggleClass2() {
  var x = document.querySelector('.custom-field__full-ingredients');
  x.classList.toggle('active');
  button2.classList.toggle('ingredients-open');
}










var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  
  
  
var addClassOnScroll = function () {
            var windowTop = $(window).scrollTop();
            $('.product__section[id]').each(function (index, elem) {
                var offsetTop = $(elem).offset().top;
                var outerHeight = $(this).outerHeight(true);

                if( windowTop > (offsetTop - 115) && windowTop < ( offsetTop + outerHeight)) {
                    var elemId = $(elem).attr('id');
                    $(".product-nav li a.active").removeClass('active');
                    $(".product-nav li a[href='#" + elemId + "']").addClass('active');
                }
            });
        };

        $(function () {
            $(window).on('scroll', function () {
                addClassOnScroll();
            });
        })
  
  

document.querySelectorAll('a.scroll[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

		const yOffset = -110; 
		const element = document.getElementById(this.getAttribute('href').substring(1));
     	const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

		window.scrollTo({top: y, behavior: 'smooth'});
      	//return false;  
      	//document.querySelector(this.getAttribute('href')).scrollIntoView({
          //  behavior: 'smooth'
        //});
    });
});
  
  
  
  
  




var headerHeight = $('.navbar').outerHeight();

jQuery(function($){
  $('#main').css({'padding-top': headerHeight + 'px'});
});

$(window).on('load', function() {
  //setHeight();
  setCircles();
});

$(window).on('resize', function() {
  //setHeight();
  setCircles();
});






var options = {
  rootMargin: '0px',
  threshold: 0.5
}

var observer = new IntersectionObserver(callback, options);

var target = document.querySelector('video');
if(target != null){
	observer.observe(target);
}

function callback(entries) {
  entries.forEach(function(entry) {
    entry.isIntersecting ? target.play() : target.pause()
  });
}



var Name = "";
        
if (navigator.userAgent.indexOf("Mac") != -1) Name = 
          "mac_os";
if (navigator.userAgent.indexOf("Linux") != -1) Name = 
          "mac_os";
if (navigator.userAgent.indexOf("Android") != -1) Name = 
          "mac_os";
if (navigator.userAgent.indexOf("like Mac") != -1) Name = 
          "mac_os";

$('body').addClass(Name);